import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import ShareYourFence from "@/pages/ShareYourFence";

export const Route = createFileRoute("/_public/share-your-fence")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Share Your Fence \u2014 Get $100 Off | Modern Fence Install", "Send us photos or videos of your Modern Fence Install project and earn $100 off future work when we use your media.", "/share-your-fence", false),
  component: ShareYourFence,
});
